<template>
  <div class="rounded border bg-white info-panel custom-table" v-if="!loaded">
    <div class="table-responsive">
      <table class="podft table table-striped table-hover table-row-dashed fs-7 table-row-gray-300 gy-3 mb-0 text-gray-800">
        <thead>
        <tr class="fw-bold fs-8 text-gray-400">
          <th style="width: 70px;">ID</th>
          <th style="width: 110px">Терминал</th>
          <th style="width: 70px; text-align: center">Статус</th>
          <th>Привязано к</th>
        </tr>
        </thead>
        <tbody>
        <tr class="align-middle cursor-pointer" v-for="item in getAccountantTerminals" :key="item.id">
          <td v-html="item.id"></td>
          <td v-html="item.terminal"></td>
          <td class="text-center">
            <i v-if="item.status" class="ki-outline ki-check-circle text-primary fs-5"></i>
            <i v-else class="ki-outline ki-cross-circle text-danger fs-5"></i>
          </td>
          <td v-html="item.branch ?? ''"></td>
          <td class="text-end">
            <i class="ki-outline ki-right-square text-primary fs-4"></i>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <loader-full v-else/>
</template>

<script>
import LoaderFull from '@/components/Main/LoaderFull';

export default {
  name: 'Terminals',
  components: {LoaderFull},
  data() {
    return {
      loaded: false
    }
  },
  mounted() {
    this.getAccountantTerminalsRequest()
  },
  computed: {
    getAccountantTerminals() { return this.$store.getters.getAccountantTerminals }
  },
  methods: {
    getAccountantTerminalsRequest() {
      this.loaded = true
      this.$store.dispatch('accountantTerminalsRequest').finally(() => this.loaded = false)
    }
  }
}
</script>

<style scoped>

</style>